import { useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Process from './components/Process';
import Technologies from './components/Technologies';
import Testimonials from './components/Testimonials';
import Stats from './components/Stats';
import CTA from './components/CTA';
import Footer from '../../components/feature/Footer';
import Navigation from '../../components/feature/Navigation';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Stats />
      <Services />
      <Process />
      <Technologies />
      <Portfolio />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
}
